import React, { useState, useEffect } from "react";
import {
  Box,
  Spacer,
  Text,
  HStack,
  Flex,
  useTheme,
  useDisclosure,
  Spinner,
} from "@chakra-ui/react";
import ScheduleClassTable from "../../../components/table/scheduleClassTable/ScheduleClassTable";
import CourseTextButton from "../../../components/buttons/CoursesTextButton";
import NumberInputLimit from "../../../components/numberInput/NumberInputLimit";
import SearchBox from "../../../components/searchbox/SearchBox";
import ClassScheduleModal from "../../../components/modals/AddModals/ClassScheduleModal";
import { useDispatch, useSelector } from "react-redux";
import { getAllClasses } from "../../../store/slice/classScheduleSlice";
import { extractFileName } from "../../../utils/extractFileNameFromUrl";
const ClassSchedule = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { primaryBlue } = theme.colors.pallete;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [editData, setEditData] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { classes, status } = useSelector((state) => state.classes);
  const [limit, setLimit] = useState(5);

  useEffect(() => {
    dispatch(getAllClasses());
  }, []);

  const filteredClasses = classes?.filter((course) =>
    course?.topicName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const transformedClasses = filteredClasses.map((item, index) => {
    const files =
      item?.liveClassRoomFiles?.map((file) => ({
        url: file.key,
        name: extractFileName(file.key),
      })) || [];

    return {
      ...item,
      sno: index + 1,
      files,
    };
  });

  const handleEditClass = (id) => {
    const selectedClass = classes.find((assignment) => assignment.id === id);
    if (selectedClass) {
      setEditData(selectedClass);
      onOpen();
    }
  };

  const handleClassSchedule = () => {
    // setEditData(null);
    onOpen();
  };
  return (
    <Box>
      <Flex>
        <Text fontWeight={500} fontSize={"18px"} color={primaryBlue}>
          Class Schedule: Completed
        </Text>

        <Spacer />
        <CourseTextButton
          text={"Schedule Class"}
          onClick={handleClassSchedule}
        />
      </Flex>
      <Flex mt={"2%"}>
        <HStack spacing={4}>
          <Text fontSize={"14px"}>Show :</Text>
          <NumberInputLimit value={limit} onChange={setLimit} />
        </HStack>

        <Spacer />

        <SearchBox onSearch={setSearchTerm} />
      </Flex>

      {status === "loading" ? (
        <Box
          height="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Spinner size="md" color="blue.500" />
        </Box>
      ) : status === "failed" ? (
        <Text>Failed to fetch the completed classes</Text>
      ) : (
        <ScheduleClassTable
          data={transformedClasses.slice(0, limit)}
          entityType="class"
          onEdit={handleEditClass}
          limit={limit}
        />
      )}

      <ClassScheduleModal
        isOpen={isOpen}
        onClose={onClose}
        editData={editData}
      />
    </Box>
  );
};

export default ClassSchedule;
